import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08ab618c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=08ab618c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab618c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ab618c')) {
      api.createRecord('08ab618c', component.options)
    } else {
      api.reload('08ab618c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08ab618c&scoped=true&", function () {
      api.rerender('08ab618c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/self-support-store/modules/upgrade-store-dialog/index.vue"
export default component.exports